import './tabler-icons.min.css';
import './index.css';
/**
 * ChainVault WP - React App Entry Point
 *
 * This is the entry point of the wallet frontend.
 * It renders the main App component into the DOM.
 *
 * @package ChainVault
 * @since   1.0.0
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { preloadVoices } from './utils/sounds';

// Preload speech synthesis voices early
// so they are ready when the first announcement plays
preloadVoices();

const root = ReactDOM.createRoot( document.getElementById( 'root' ) );
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);